import { CommonMessage } from '@frontend/lang';
import { SpotSelectV2 } from '@frontend/spot/select';
import { FormattedMessage } from 'react-intl';

import KioskRadioButton from '../../../components/kiosk-radio-button/kiosk-radio-button.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useSelectOrderDeliveryLocation } from './select-order-delivery-location.controller';

const ID = 'select-order-delivery-location';

export const SelectOrderDeliveryLocation = () => {
    const viewProps = useSelectOrderDeliveryLocation();
    const hasSameCurrentAndDefaultSpot = Boolean(viewProps.currentSpot?.id && viewProps.currentSpot.id === viewProps.defaultSpot?.id);

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.OBJECTS.SPOT.DISTRI_SPOT, onBack: viewProps.onBack }}
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.confirmOrder,
                submitDisabled: !viewProps.selectedProduct || !viewProps.selectedSpot || viewProps.isSubmitting,
                submitLabel: (
                    <FormattedMessage
                        id='kiosk.wizard.select-order-delivery-location.confirm-order'
                        defaultMessage='Confirm order'
                        description='Submit button that places a kiosk product order with the selected delivery distriSPOT'
                    />
                )
            }}>
            <div className='flex flex-col gap-3'>
                <p className='text-foreground-muted'>
                    <FormattedMessage
                        id='kiosk.wizard.select-order-delivery-location.instruction'
                        defaultMessage='Choose where you would like this order delivered.'
                        description='Instruction on the kiosk order delivery location screen'
                    />
                </p>
                <KioskRadioButton
                    id={`${ID}-current-spot`}
                    text={
                        <FormattedMessage
                            id='kiosk.wizard.select-order-delivery-location.current-spot'
                            defaultMessage='Current distriSPOT'
                            description='Option label for delivering a kiosk order to the current distriSPOT'
                        />
                    }
                    subtext={viewProps.currentSpot?.name}
                    selected={viewProps.selectedDeliveryOption === 'current'}
                    onClick={viewProps.selectCurrentSpot}
                    disabled={!viewProps.currentSpot}
                />
                {!hasSameCurrentAndDefaultSpot && (
                    <KioskRadioButton
                        id={`${ID}-default-spot`}
                        text={
                            <FormattedMessage
                                id='kiosk.wizard.select-order-delivery-location.default-spot'
                                defaultMessage='My default distriSPOT'
                                description='Option label for delivering a kiosk order to the user default distriSPOT'
                            />
                        }
                        subtext={viewProps.defaultSpot?.name}
                        selected={viewProps.selectedDeliveryOption === 'default'}
                        onClick={viewProps.selectDefaultSpot}
                        disabled={!viewProps.defaultSpot || viewProps.isLoadingDefaultSpot}
                    />
                )}
                <div className='flex items-center gap-3 py-2'>
                    <div className='border-border-default flex-1 border-t' />
                    <p className='text-foreground-muted text-sm font-medium'>
                        <FormattedMessage
                            id='kiosk.wizard.select-order-delivery-location.other-spots'
                            defaultMessage='Other distriSPOTs'
                            description='Divider label above the selector of delivery distriSPOTs other than the default and current choices on kiosk'
                        />
                    </p>
                    <div className='border-border-default flex-1 border-t' />
                </div>
                <div className={viewProps.selectedDeliveryOption === 'other' ? 'border-brand-primary rounded-xl border-2 p-1' : ''}>
                    <SpotSelectV2
                        id={`${ID}-another-spot`}
                        value={viewProps.selectedAnotherSpot?.id ?? null}
                        onChangeObject={(spot) => spot && viewProps.selectAnotherSpot(spot)}
                        excludeSpotIds={[
                            ...new Set([viewProps.currentSpot?.id, viewProps.defaultSpot?.id].filter((spotId): spotId is string => Boolean(spotId)))
                        ]}
                        hideLabel
                        isClearable={false}
                    />
                </div>
            </div>
        </WizardScreenContainer>
    );
};
